import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { logout } from '../features/auth/authSlice';
import { useNavigate } from 'react-router-dom';


function Logout() {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    const logoutUser = async () => {
      dispatch(logout());
      navigate('/login');
    };

    logoutUser();
  }, [dispatch, navigate]);

  return ;
};

export default Logout;

